import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Modal, Button } from '@storable/canaveral-components';


const propTypes = {
  facilityId: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  submitted: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  submitErrors: PropTypes.arrayOf(PropTypes.shape({
    message: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
  })),
};

const defaultProps = {
  submitErrors: undefined,
};

const FacilityRefreshModal = ({
  facilityId,
  show,
  onSubmit,
  onDismiss,
  submitted,
  submitting,
  submitErrors,
}) => (
  <Modal
    show={show}
    onDismiss={onDismiss}
    size="sm"
  >
    <Modal.Header>
      <Modal.Title id="admin-add-page">Refresh Facility Data</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {submitErrors && submitErrors.map(error => <Alert context="danger">{error.message}</Alert>)}
      {submitted
          && (<Alert context="success">Facility data refreshed. Close this modal to refresh the application and see updated facility data.</Alert>)
        }
      <p>Facility id: {facilityId}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button
        data-testid="facility-refresh-close-button"
        size="sm"
        context="neutral"
        disabled={submitting}
        onClick={onDismiss}
      >
          Close
      </Button>
      <Button
        data-testid="facility-refresh-submit-button"
        size="sm"
        context="positive"
        onClick={onSubmit}
        loading={submitting}
      >
          Refresh
      </Button>
    </Modal.Footer>
  </Modal>
);

FacilityRefreshModal.propTypes = propTypes;
FacilityRefreshModal.defaultProps = defaultProps;

export default FacilityRefreshModal;
